export type Locale =
  | 'tr-TR'
  | 'pl-PL'
  | 'zh-TW'
  | 'th-TH'
  | 'id-ID'
  | 'el-GR'
  | 'nl-NL'
  | 'vi-VN'
  | 'da-DK'
  | 'sv-SE'
  | 'fi-FI'
  | 'nb-NO'
  | 'he-IL'
  | 'en-US'
  | 'en-GB'
  | 'pt-BR'
  | 'es-ES'
  | 'ar-AE'
  | 'fr-FR'
  | 'de-DE'
  | 'it-IT'
  | 'ru-RU'
  | 'ja-JP'
  | 'ko-KR'
  | 'zh-CN';

export const getToken = (locale: Locale, isProd: boolean) => {
  switch (locale) {
    case 'en-US':
      return 'c72849c6-2a3c-8a3b-bf17-94885baf8879';
    case 'ar-AE':
      return !isProd ? 'e8a74708-8b5f-7ae4-c3c7-1e9ec97f59e9' : 'e82845cc-608b-3988-3738-6d94a31f25c3';
    case 'pt-BR':
      return !isProd ? 'd8594878-a7f0-a616-d5d4-4c089fc1834f' : '6188f3d9-3d5e-7766-55fd-a6e5720a3a93';
    case 'de-DE':
      return !isProd ? '4353f5be-67e7-0c90-adaa-25acad1caeb5' : '29d3a038-a1a0-764f-ce18-1d8e982119b5';
    case 'es-ES':
      return !isProd ? '47bd5df5-d130-2c05-b9db-c62ec830c0c8' : 'a9d7be5b-6882-0dc7-01bb-c02e98f373d4';
    case 'fr-FR':
      return !isProd ? 'd6cd3157-7fd9-88d7-2bce-5ebcfb282e40' : '5a97b514-7476-07c1-f33d-4931ac773623';
    case 'it-IT':
      return !isProd ? '5753a520-f532-5f0b-1409-d0bd6e5f63b6' : '3941ba71-530a-e7e9-c608-4a33f0e15889';
    case 'ja-JP':
      return !isProd ? '8d6245e6-0c72-f153-bcf5-dfdc1258a8dd' : 'ca911cbd-a824-da2d-b2d6-a3ce8fc631cb';
    case 'ko-KR':
      return !isProd ? '822e9584-31f2-fbd9-d3d8-5b9ab9aedba5' : 'ea5b4ebb-8abb-1094-15c3-6b11e5eb260b';
    case 'ru-RU':
      return !isProd ? '2aeb8eec-755a-c5ee-7b1e-f13e4b45af0d' : '3d18e31d-03e1-4442-4bd9-67d867537836';
    case 'en-GB':
      return !isProd ? 'e9d05ac2-6c5a-cac5-908f-39f88f3b5901' : '9ff2ad6d-b427-54a5-7b9e-30161c2f5448';
    case 'zh-CN':
      return !isProd ? '3c4b8866-4641-e2f7-3fe1-c7752fb5a698' : 'c67fd1da-c6c4-5cc8-b0d0-d046748b752a';
    default:
      return '';
  }
};
